<template>
  <div>
    <div
      v-if="REVIEWS.length"
      class="review-stats"
    >
      <div class="review-stats__title">
        Общая оценка
      </div>

      <div class="review-stats__body">
        <div class="review-stats__stat">
          <div class="review-stats__stat-title">
            Рекомендуют:
          </div>
          <div class="review-stats__stat-value">
            {{ REVIEWS_SUMMARY.recommended || 0 }} %
          </div>
        </div>

        <div class="review-stats__total-score">
          {{ REVIEW_RATING }}
        </div>

        <div class="review-stats__stat">
          <div class="review-stats__stat-title">
            Отзывов:
          </div>
          <div class="review-stats__stat-value">
            {{ REVIEWS_COUNT }}
          </div>
        </div>
      </div>

      <stars-rating
        class="review-stats__stars-rating"
        :size="starsSize"
        :value="REVIEW_RATING"
      />

      <div class="review-stats__size">
        <div class="review-stats__size-title">
          Соответствие размеру
        </div>

        <div class="review-stats__size-bars">
          <radial-bar
            :value="sizeSmall"
            title="Маломерит"
          />
          <radial-bar
            :value="sizeNormal"
            title="Соответствует"
          />
          <radial-bar
            :value="sizeLarge"
            title="Большемерит"
          />
        </div>

        <div class="review-stats__sizes-rating">
          <horizontal-bar
            class="review-stats__sizes-rating-item"
            :value="fit"
            title="Посадка"
          />
          <horizontal-bar
            class="review-stats__sizes-rating-item"
            :value="quality"
            title="Качество"
          />
          <horizontal-bar
            :value="photoAccuracy"
            title="Соответствие фото"
          />
        </div>

        <ui-button
          :large="buttonIsLarge"
          wide
          text="Оставить отзыв"
          @click="$emit('show-form')"
        />
      </div>
    </div>

    <div
      v-else
      class="review-stats__no-reviews"
    >
      <div class="review-stats__no-reviews-title">
        Поделитесь своим мнением о товаре
      </div>
      <div class="review-stats__no-reviews-text">
        Это поможет другим покупателям принять решение о покупке
      </div>
      <ui-button
        :large="buttonIsLarge"
        wide
        text="Оставить отзыв"
        @click="$emit('show-form')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StarsRating from './stars-rating.vue';
import RadialBar from './radial-bar.vue';
import HorizontalBar from './horizontal-bar.vue';
export default {
  name: "review-stats",

  components: { StarsRating, RadialBar, HorizontalBar },

  inject: ['adaptive'],

  computed: {
    ...mapGetters({
      REVIEWS_SUMMARY: 'product/reviewProductSummary',
      REVIEWS_COUNT: 'product/reviewsСount',
      REVIEW_RATING: 'product/reviewRating',
      REVIEWS: 'product/productReviews',
    }),

    sizeSmall() {
      return this.REVIEWS_SUMMARY?.dimensions?.small || 0
    },
    sizeNormal() {
      return this.REVIEWS_SUMMARY?.dimensions?.normal || 0
    },
    sizeLarge() {
      return this.REVIEWS_SUMMARY?.dimensions?.large || 0
    },
    fit() {
      return  this.REVIEWS_SUMMARY?.rating_details?.fit || 0
    },
    quality() {
      return  this.REVIEWS_SUMMARY?.rating_details?.quality || 0
    },
    photoAccuracy() {
      return  this.REVIEWS_SUMMARY?.rating_details?.photo_accuracy || 0
    },
    buttonIsLarge() {
      return this.adaptive.isDesktop;
    },
    starsSize() {
      if (this.adaptive.isDesktop) {
        return '52';
      } else if (this.adaptive.isTablet) {
        return '32';
      }

      return '48';
    },
  },
}
</script>

<style lang="scss">
  .review-stats {
    @include breakpoint("tablet") {
      border: 1px solid $gray_lu;
      padding: 16px 16px 24px;
      border-radius: 4px;
    }

    @include breakpoint("desktop") {
      padding: 24px;
    }

    &__title {
      font-family: "Gilroy";
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 8px;

      @include breakpoint("tablet") {
        font-size: 14px;
        line-height: 16px;
      }

      @include breakpoint("desktop") {
        font-size: 20px;
        line-height: 28px;
      }
    }

    &__stat-title {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 4px;

      @include breakpoint("tablet") {
        font-size: 8px;
        margin-bottom: 0;
      }

      @include breakpoint("desktop") {
        font-size: 12px;
      }
    }

    &__stat-value {
      font-size: 26px;
      font-weight: bold;
      text-align: center;

      @include breakpoint("tablet") {
        font-size: 16px;
      }

      @include breakpoint("desktop") {
        font-size: 26px;
      }
    }

    &__total-score {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 102px;
      height: 102px;
      font-size: 52px;
      border-radius: 60px;
      background: $blue_8;
      flex-shrink: 0;

      @include breakpoint("tablet") {
        width: 64px;
        height: 64px;
        font-size: 36px;
      }

      @include breakpoint("desktop") {
        width: 116px;
        height: 116px;
        font-size: 64px;
      }
    }

    &__body {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      margin-bottom: 12px;

      @include breakpoint("tablet") {
        margin: 0 -24px 12px;
      }
    }

    &__stars-rating {
      margin-bottom: 22px;

      @include breakpoint("tablet") {
        margin-bottom: 8px;
      }

      @include breakpoint("desktop") {
        margin-bottom: 22px;
      }
    }

    &__size-title {
      font-size: 14px;
      line-height: 24px;
      color: $gray;
      text-align: center;
      margin-bottom: 16px;

      @include breakpoint("tablet") {
        margin-bottom: 12px;
        font-size: 12px;
        line-height: 20px;
      }

      @include breakpoint("desktop") {
        font-size: 16px;
        margin-bottom: 24px;
      }
    }

    &__size-bars {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 24px;

      .radial-bar {
        flex: 0 1 auto;
      }
    }

    &__sizes-rating {
      margin-bottom: 25px;

      @include breakpoint("tablet") {
        margin-bottom: 29px;
      }
    }

    &__sizes-rating-item {
      margin-bottom: 7px;
    }

    &__no-reviews {
      padding: 16px;
      border: 1px solid $gray_lu;
      border-radius: 4px;

      @include breakpoint("desktop") {
        padding: 24px;
      }
    }

    &__no-reviews-title {
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      margin-bottom: 4px;

      @include breakpoint("tablet") {
        margin-bottom: 7px;
      }

      @include breakpoint("desktop") {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 8px;
      }
    }

    &__no-reviews-text {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;

      @include breakpoint("tablet") {
        margin-bottom: 25px;
      }

      @include breakpoint("desktop") {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 20px;
      }
    }
  }
</style>